import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';

const AppRoutes = () => {
  const location = useLocation();
  const { isLoggedIn } = useSelector((state) => state.account);
  const path = location.pathname.toLowerCase();

  const isVideoFile = /\.(mp4|mov)$/i.test(path.split('?')[0]);

  const loginPaths = ['/login', '/authlogin', '/forgot_password'];

  if (!isLoggedIn && !isVideoFile && !loginPaths.some(p => path.startsWith(p))) {
    return <Navigate to="/login" replace />;
  }

  if (isLoggedIn && loginPaths.includes(path)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={isLoggedIn ? "/dashboard" : "/login"} replace />} />

      {loginPaths.some(p => path.startsWith(p))
        ? <Route path="/*" element={<LoginRoutes />} />
        : <Route path="/*" element={<MainRoutes />} />
      }
    </Routes>
  );
};

export default AppRoutes;